import { alphaSorter } from 'vet-bones/utils';

import {
  Model,
  ModelSnapshot,
} from 'src/containers/ProjectDiagram/types/model';
import { isModelConceptRelationship } from 'src/containers/ProjectDiagram/utils/data';
import { getModelConceptClassValue } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';

export const getClassIrisForSuggestionsRequest = (
  selectedClassIris: string[],
  model: Model | ModelSnapshot
) => {
  if (!selectedClassIris.length) {
    return selectedClassIris;
  }

  const classIris = new Set<string>(selectedClassIris);
  model.linkDataArray.forEach((linkData) => {
    const { from, to } = linkData;
    if (isModelConceptRelationship(linkData) && from && to) {
      const fromIri = getModelConceptClassValue(from);
      const toIri = getModelConceptClassValue(to);
      if (
        selectedClassIris.includes(fromIri) ||
        selectedClassIris.includes(toIri)
      ) {
        classIris.add(fromIri);
        classIris.add(toIri);
      }
    }
  });
  return Array.from(classIris).sort(alphaSorter);
};
